import styled from "styled-components";
import imgFondo from "../../assets/images/factor-ct/fondo.png";

export const FactorCtContainerStyled = styled.div`
  background-color: #00a8c4;
  padding: 20px;
  background-image: url(${imgFondo});
  background-size: contain;
  padding-bottom: 60px;
`;

export const MaxWidth = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    max-height: 50px;
    height: 100px;

    margin-right: 15px;
  }

  @media (max-width: 768px) {
    img {
      margin-right: 0;
    }
  }

  @media (max-width: 440px) {
    div {
      &:last-child {
        img {
          max-width: 110px;
          &:last-child {
            display: none;
          }
        }
      }
    }
  }
`;

export const Titles = styled.div`
  img {
    width: 200px;
    height: 100px;
    max-height: initial;
  }
`;

export const AfirmationsContainer = styled.div`
  h1 {
    padding: 0;
    margin: 0;
  }
`;

export const YesColumn = styled.div`
  width: 50px;
  justify-content: center;
  display: flex;
  font-size: 12px;
`;

export const NoColumn = styled.div`
  width: 50px;
  justify-content: center;
  display: flex;
  font-size: 12px;
`;

export const NAColumn = styled.div`
  width: 50px;
  justify-content: center;
  display: flex;
  font-size: 12px;
`;

export const AfirmationsHeader = styled.div`
  background-color: #003a4b;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 20px;
  -webkit-box-shadow: -6px 11px 16px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -6px 11px 16px -8px rgba(0, 0, 0, 0.75);
  box-shadow: -6px 11px 16px -8px rgba(0, 0, 0, 0.75);
  position: sticky;
  top: 0px;
  z-index: 1;

  ${YesColumn},${NAColumn}, ${NoColumn} {
    background-color: rgb(202, 195, 200);
    width: 50px;
    border: none;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: black;
  }

  @media (max-width: 440px) {
    font-size: 8px;
  }
`;

export const AfirmationColumn = styled.div`
  width: calc(100% - 150px - 40px); //40 padding and 150 columns

  /* ${AfirmationsHeader} & {
    
    @media (max-width: 440px) {
      font-size: 12px;
    }
  } */
`;

export const AfirmationContainer = styled.div`
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 10px;
  -webkit-box-shadow: -6px 11px 16px -8px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: -6px 11px 16px -8px rgba(0, 0, 0, 0.75);
  box-shadow: -6px 11px 16px -8px rgba(0, 0, 0, 0.75);
`;

export const Answer = styled.div`
  background-color: #cac3c8;
  width: 50px;
  border: none;
  height: 30px;
  font-size: 50px;
  text-align: center;
  cursor: pointer;
  caret-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &.X {
    &::after {
      content: " ";
      position: absolute;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #000;
    }
  }
`;

export const InstruccionesContainer = styled.div`
  /*90px es por el tama�o del header eso se debe arreglar para que quedde bien */
  min-height: calc(100vh - 40px - 187px);
  padding: 20px;
`;

export const ButtonCt = styled.button`
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  position: fixed;
  right: 20px;
  bottom: 20px;
  cursor: pointer;

  img {
    max-height: 50px;
  }

  :disabled {
    img {
      opacity: 0.5;
    }
  }
`;

export const PdfAlreadyGenerated = styled.div`
  
  padding: 20px;
  text-align: center;
  background-color: white;
  margin: 0;
  border: none;
  position: fixed;
  right: 0px;
  bottom: 0px;
  left: 0;
  a {
    text-decoration: bold;
  }  
`;

export const InstruccionesInside = styled.div`
  text-align: center;
  color: white;
  font-weight: 500;
  font-size: 18px;

  h1 {
    margin-bottom: 20px;
  }
`;

export const InstruccionRow = styled.div`
  display: flex;
  gap: 20px;

  img {
    width: 150px;
  }

  .parrafo {
    text-align: justify;

    b {
      font-weight: 900;
    }

    &.pequeno {
      font-size: 14px;
    }
  }

  @media (max-width: 440px) {
    img {
      display: none;
    }
  }
`;

export const InstruccionRowImgContainer = styled.div`
  display: flex;
  align-items: center;
`;
